import { router } from "@inertiajs/react"
import { Trash2 } from "lucide-react"

type Props = {
  type: "Band" | "Person" | "Recording" | "Venue" | "RecordLabel"
  id: number
  name: string
}

export function RequestDeletionButton({ type, id, name }: Props) {
  function handleClick() {
    const reason = prompt(
      `Request deletion of "${name}"?\n\nOptionally enter a reason (shown to admins):`,
    )
    if (reason === null) return
    router.post("/deletion_requests", {
      requestable_type: type,
      requestable_id:   id,
      reason:           reason || undefined,
    })
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/30 hover:bg-amber-100 dark:hover:bg-amber-950/50 rounded-lg transition-colors"
    >
      <Trash2 className="w-3.5 h-3.5" />
      Request Deletion
    </button>
  )
}
